export const TITLE = "Mahindra Treo Plus Price in 2026 - Range, Specification & Reviews | Turno";

export const META_NAME = "description";

export const META_KEYWORDS_NAME = "keywords";

export const META_KEYWORDS_CONTENT =
  "mahindra auto battery wala, treo auto price, mahindra electric auto, mahindra e rickshaw, e rickshaw price mahindra, mahindra treo on road price, mahindra electric auto showroom near me, mahindra auto rickshaw, mahindra electric auto price, mahindra electric 3 wheeler price, mahindra e rickshaw price on road, mahindra treo e rickshaw, mahindra electric auto price, mahindra e rickshaw price, mahindra electric auto, mahindra treo battery price, mahindra ev auto, mahindra electric vehicle, mahindra treo electric auto price, mahindra battery auto, mahindra electric auto showroom near me, mahindra battery auto price";

export const META_CONTENT = [
  {
    name: "description",
    content:
      "Looking for Mahindra Treo Plus price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "keywords",
    content:
      "mahindra auto battery wala, treo auto price, mahindra electric auto, mahindra e rickshaw, e rickshaw price mahindra, mahindra treo on road price, mahindra electric auto showroom near me, mahindra auto rickshaw, mahindra electric auto price, mahindra electric 3 wheeler price, mahindra e rickshaw price on road, mahindra treo e rickshaw, mahindra electric auto price, mahindra e rickshaw price, mahindra electric auto, mahindra treo battery price, mahindra ev auto, mahindra electric vehicle, mahindra treo electric auto price, mahindra battery auto, mahindra electric auto showroom near me, mahindra battery auto price",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content: "https://www.turno.club/electric-commercial-vehicles/Mahindra/treo-plus",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Mahindra/treo-plus",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "Mahindra Treo Plus Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    property: "og:description",
    content:
      "Looking for Mahindra Treo Plus price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "Looking for Mahindra Treo Plus price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026.",
  },
  {
    name: "twitter:title",
    content: "Mahindra Treo Plus Price in 2026 - Range, Specification & Reviews | Turno",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Mahindra/treo-plus",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const KEY_SPECIFICATION_HEADER = "Key Specifications";

export const HIGHLIGHTS_HEADER = "Highlights of Mahindra Electric Auto";

export const SUB_TEXT =
  "The Treo Plus is not just a vehicle: it's a sustainable and profitable business opportunity for drivers. With its low operating costs and high passenger capacity, this Mahindra e-rickshaw is helping drivers and vehicle owners earn a steady income while contributing to a greener future. If you're looking for an eco-friendly, cost-effective, and reliable last-mile mobility solution, the Mahindra Treo Plus is worth considering.";

export const BENEFITS_HEADER = "Benefits of Mahindra Treo Plus";

export const VEHICLE_FEATURE_HEADER = "Features of Mahindra Treo Plus";

export const BRAND_DEALER_HEADER = "Mahindra Electric Auto Showroom Near Me";

export const BRAND_DEALER_DESCRIPITION =
  "You may find many Mahindra electric auto dealers near you but if you want the best EV buying and owning experience, you must visit Turno, India’s #1 EV Dealer. At Turno, we don’t only sell EVs, we also provide excellent after-sale support such as assured vehicle buyback, dedicated relationship manager, arranging roadside assistance and additional EV services.";

export const FAQ_HEADER_TEXT = "FAQs on Mahindra Treo Plus";

export const H1_HEADING = "Mahindra Treo Plus";

export const VEHICLE_LINK = "https://www.turno.club/electric-commercial-vehicles/Mahindra/treo-plus";

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "Mahindra", href: "/electric-commercial-vehicles/Mahindra" },
  { label: "Treo Plus", href: VEHICLE_LINK },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Mahindra",
      item: "https://www.turno.club/electric-commercial-vehicles/Mahindra",
    },
    {
      "@type": "ListItem",
      position: 4,
      name: "Mahindra Treo Plus",
      item: VEHICLE_LINK,
    },
  ],
};